import { useEffect } from 'react'
import { MIN_CANVAS_WIDTH_PX, shouldAutoCollapseRightPanel } from '../helpers/canvas-width'
import { YARD_DRAWERS_WIDTH } from '../helpers/yard-view.utils'
import { YardViewStore } from '../stores/yard.view-store'

interface Guard {
  viewStore: Pick<YardViewStore, 'setContainerDetailsOpen'>
  isLeftDrawerOpen: boolean
  isRightDrawerOpen: boolean
  rightDrawerWidth: number
  viewportWidth: number
}

// isRightDrawerOpen must be passed as a primitive prop (not read off viewStore
// inside the effect) so React's dep array sees it change. Reading the MobX
// observable directly here would skip the open→narrow case: the viewStore
// object reference is stable, so the effect never re-runs on open without an
// independent dep changing.
//
// viewportWidth is also passed in as a primitive so this hook doesn't register
// its own `resize` listener — `Yard.tsx` owns the single `useViewportWidth()`
// call for the whole page and forwards the value down.
export const useCanvasWidthGuard = ({
  viewStore,
  isLeftDrawerOpen,
  isRightDrawerOpen,
  rightDrawerWidth,
  viewportWidth,
}: Guard) => {
  useEffect(() => {
    if (
      shouldAutoCollapseRightPanel({
        viewportWidth,
        leftDrawerOpen: isLeftDrawerOpen,
        rightDrawerOpen: isRightDrawerOpen,
        leftDrawerWidth: YARD_DRAWERS_WIDTH,
        rightDrawerWidth,
        minCanvasWidth: MIN_CANVAS_WIDTH_PX,
      })
    ) {
      viewStore.setContainerDetailsOpen(false)
    }
  }, [viewportWidth, isLeftDrawerOpen, isRightDrawerOpen, rightDrawerWidth, viewStore])
}
